import Vue from 'vue'
import Vuex from 'vuex'
import Storage from '@/helpers/storage'
import Api from '@/api'
import ENUM from '@/assets/ENUM'

import UCUser from '@/app-core/use-cases/user'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {},
        stats: {},
        settings: {},
        partners: {},
        email: '',
        scroll: false,
        lang: '',
        page: '',
        maintenance: false,
        internet: true,
        fastPass: false,
        newsletters: {subscriptions: []},
        newslettersWaitingUserRefresh: {},
        countSelectedNewsletters: 0,
        unselectedAllNewsletters: false,
        newslettersSort: ENUM.NEWSLETTERS.SORT.NOT_SET,
        newslettersLoaded: false,
        isConnected: false,
        fetching: false,
        mailboxes: [],
        isCardTuto: false,
        showBottomSheetAddMailbox: false,
        showScanMailboxesEnding: false,
        actualPartner: {},
        newslettersSearchingMode: ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE,
        searchValue: '',
        newslettersPage: '',
        isCardDraging: false,
        cardDragDirection: '',
        emailToDeleteRedirect: ''
    },
    mutations: {
        
        UPDATE_USER: (state, user) => {
            state.user = user
        },
        
        UPDATE_STATS: (state, stats) => {
            
            state.stats = stats
        },
        
        UPDATE_SETTINGS: (state, settings) => {
            state.settings = settings
        },
        
        UPDATE_PARTNERS: (state, partners) => {
            state.partners = partners
        },
        
        EMAIL: (state, email) => {
            state.email = email
        },
        
        SCROLL: (state, bool) => {
            state.scroll = bool
        },
        
        LANG: (state, lang) => {
            state.lang = lang
        },
        
        PAGE: (state, page) => {
            state.page = page
        },
        
        MAINTENANCE: (state, maintenance) => {
            state.maintenance = maintenance
        },
        
        INTERNET: (state, internet) => {
            state.internet = internet
        },
        
        UPDATE_FAST_PASS: (state, fastPass) => {
            state.fastPass = fastPass
        },
        
        NEWSLETTERS: (state, newsletters) => {
            state.newsletters = newsletters
            state.newslettersLoaded = true
        },
        
        NEWSLETTERS_WAITING_USER_REFRESH: (state, newslettersWaitingUserRefresh) => {
            state.newslettersWaitingUserRefresh = newslettersWaitingUserRefresh
        },
        
        COUNT_SELECTED_NEWSLETTERS: (state, countSelectedNewsletters) => {
            state.countSelectedNewsletters = countSelectedNewsletters
        },
        
        UNSELECT_ALL_NEWSLETTERS: (state, unselectedAllNewsletters) => {
            state.unselectedAllNewsletters = unselectedAllNewsletters
        },
        
        NEWSLETTERS_SORT: (state, newslettersSort) => {
            state.newslettersSort = newslettersSort
        },
        
        IS_CONNECTED: (state, isConnected) => {
            state.isConnected = isConnected
        },
        
        FETCHING: (state, fetching) => {
            state.fetching = fetching
        },
        
        MAILBOXES: (state, mailboxes) => {
            state.mailboxes = mailboxes
        },
        
        IS_CARD_TUTO: (state, isCardTuto) => {
            state.isCardTuto = isCardTuto
        },
        
        SHOW_BOTTOM_SHEET_ADD_MAILBOX: (state, showBottomSheetAddMailbox) => {
            state.showBottomSheetAddMailbox = showBottomSheetAddMailbox
        },
    
        SHOW_SCAN_MAILBOXES_ENDING: (state, showScanMailboxesEnding) => {
            state.showScanMailboxesEnding = showScanMailboxesEnding
        },

        ACTUAL_PARTNER: (state, actualPartner) => {
            state.actualPartner = actualPartner
        },

        NEWSLETTERS_SEARCHING_MODE: (state, mode) => {
            state.newslettersSearchingMode = mode
        },

        UPDATE_SEARCH_VALUE: (state, value) => {
            state.searchValue = value
        },

        UPDATE_NEWSLETTERS_PAGE: (state, newPage) => {
            state.newslettersPage = newPage
        },

        UPDATE_CARD_DRAGING: (state, bool) => {
            state.isCardDraging = bool
        },

        UPDATE_CARD_DRAG_DIRECTION: (state, direction) => {
            state.cardDragDirection = direction
        },

        EMAIL_TO_DELETE_REDIRECT: (state, emailToDeleteRedirect) => {
            state.emailToDeleteRedirect = emailToDeleteRedirect
        }
        
    },
    getters: {
        user: state => state.user,
        stats: state => state.stats,
        settings: state => state.settings,
        partners: state => state.partners,
        scroll: state => state.scroll,
        lang: state => state.lang,
        page: state => state.page,
        maintenance: state => state.maintenance,
        internet: state => state.internet,
        fastPass: state => state.fastPass,
        newsletters: state => state.newsletters,
        newslettersWaitingUserRefresh: state => state.newslettersWaitingUserRefresh,
        countSelectedNewsletters: state => state.countSelectedNewsletters,
        unselectedAllNewsletters: state => state.unselectedAllNewsletters,
        newslettersSort: state => state.newslettersSort,
        newslettersLoaded: state => state.newslettersLoaded,
        isConnected: state => state.user && state.user.hash,
        fetching: state => state.fetching,
        mailboxes: state => state.mailboxes,
        isCardTuto: state => state.isCardTuto,
        showBottomSheetAddMailbox: state => state.showBottomSheetAddMailbox,
        showScanMailboxesEnding: state => state.showScanMailboxesEnding,
        actualPartner: state => state.actualPartner,
        anonymousUser: state => {
            // If user is not connected, we cannot known if the user is anonymous or not
            return state.isConnected && state.user &&
                (!state.user.firstname || (!state.user.birthYear || state.user.birthYear < 1))
        },
        newslettersSearchingMode: state => state.newslettersSearchingMode,
        searchValue: state => state.searchValue,
        newslettersPage: state => state.newslettersPage,
        isCardDraging: state => state.isCardDraging,
        cardDragDirection: state => state.cardDragDirection,
        emailToDeleteRedirect: state => state.emailToDeleteRedirect || Storage.getItem('emailToDeleteRedirect')
    },
    actions: {
        
        setUser: (store, user = {}) => store.commit('UPDATE_USER', user),
        
        disconnect(store) {
            
            Storage.removeItem('token')
            store.commit('UPDATE_USER', {})
        },
        
        getUserAsync: function (store) {
    
            if (store.state.user && store.state.user.accounts) {
                return Promise.resolve(store.state.user)
            } else {
                return UCUser.getUserAsync()
                    .then(user => {
                        return store.dispatch('updateUser', user)
                    })
            }
        },

        getUserSync: async function(store) {
            return await UCUser.getUserSync()
                .then(user => {
                    return store.dispatch('updateUser', user)
                })
        },

        updateUser(store, user) {
            store.dispatch('setUser', user)
            store.dispatch('updateMailboxes', user.accounts)
            return user
        },
        
        getStatsAsync: async function ({commit, state}) {
            
            //refresh always stats, but some modules need stats
            return Api.user.getStats()
                .then(stats => {
                    commit('UPDATE_STATS', stats)
                    return stats
                })
        },
        
        getSettingsAsync: function ({commit, state}) {
            return Api.user.getSettings()
                .then(settings => {
                    commit('UPDATE_SETTINGS', settings)
                    return settings
                })
        },
        
        getPartnersAsync: function ({commit, state}) {
            if (Object.keys(state.partners).length) {
                return state.partners
            }
            return Api.partners.getAll()
                .then(partners => {
                    commit('UPDATE_PARTNERS', partners)
                    return partners
                })
        },
        
        setLang: (store, lang) => store.commit('LANG', lang),
        
        setPage: (store, page) => store.commit('PAGE', page),
        
        setMaintenance: (store, maintenance) => store.commit('MAINTENANCE', maintenance),
        
        setInternetStatus: (store, bool) => store.commit('INTERNET', bool),
        
        updateFastPass: (store, bool) => store.commit('UPDATE_FAST_PASS', bool),

        updateNewsletters: (store, newsletters) => store.commit('NEWSLETTERS', newsletters),
        
        updateNewslettersWaitingUserRefresh: (store, newslettersWaitingUserRefresh) => store.commit('NEWSLETTERS_WAITING_USER_REFRESH', newslettersWaitingUserRefresh),
        
        refreshNewsletters: async (store, asyncFetchMeantime) => {
            if(Storage.getItem('token')) {
    
                store.dispatch('updateFetching', true)
                const data = await UCUser.refreshSubscriptions(asyncFetchMeantime)
                store.dispatch('updateFetching', false)
    
                store.dispatch('updateNewsletters', data)
                store.dispatch('updateMailboxes', data.mailboxes)
                return data
            }
        },
        
        refreshUnfinishedMailboxes: async (store) => {
            const data = await  UCUser.waitUnfinishedMailboxes()
            store.dispatch('updateNewslettersWaitingUserRefresh', data)
            store.dispatch('updateShowScanMailboxesEnding', true)
        },
        
        userAcceptNewSubscriptions(store) {
            const newsletters = store.getters.newslettersWaitingUserRefresh
            store.dispatch('updateNewsletters', newsletters)
            store.dispatch('updateMailboxes', newsletters.mailboxes)
            store.dispatch('updateNewslettersWaitingUserRefresh', {})
            store.dispatch('updateShowScanMailboxesEnding', false)
        },
        
        updateSubscriptions: (store, subscriptions) => {
            const newsletters = {...store.getters.newsletters} //clone for break VUEX mutation error
            newsletters.subscriptions = subscriptions
            store.dispatch('updateNewsletters', newsletters)
        },
        
        updateCountSelectedNewsletters: (store, countSelectedNewsletters) => store.commit('COUNT_SELECTED_NEWSLETTERS', countSelectedNewsletters),
        
        unselectAllNewsletters: (store) => {
            store.commit('COUNT_SELECTED_NEWSLETTERS', 0)
            store.commit('UNSELECT_ALL_NEWSLETTERS', !store.getters.unselectedAllNewsletters)
        },
        
        updateNewslettersSort: (store, newslettersSort) => {
            store.commit('NEWSLETTERS_SORT', newslettersSort)
            Storage.setItem('newslettersSort', newslettersSort)
        },
        
        updateFetching: (store, fetching) => store.commit('FETCHING', fetching),
        
        updateMailboxes: (store, mailboxes) => {
            const newMailboxes = UCUser.mergeMailboxes(mailboxes, store.getters.mailboxes)
            store.commit('MAILBOXES', newMailboxes)
        },
        
        updateIsCardTuto: (store, isCardTuto) => store.commit('IS_CARD_TUTO', isCardTuto),
        
        updateShowBottomSheetAddMailbox: (store, showBottomSheetAddMailbox) => store.commit('SHOW_BOTTOM_SHEET_ADD_MAILBOX', showBottomSheetAddMailbox),
        
        removeMailboxes: (store, removedEmail) => {
            const currentMailboxes = JSON.parse(JSON.stringify(store.state.mailboxes))
            const newMailboxes = currentMailboxes.filter(mailbox => mailbox.email !== removedEmail)
            store.dispatch('updateMailboxes', newMailboxes)
        },
        
        initNewsletterSort: (store, removedEmail) => {
            const newslettersSort = Storage.getItem('newslettersSort')
            if (newslettersSort && Object.values(ENUM.NEWSLETTERS.SORT).includes(newslettersSort)) {
                store.dispatch('updateNewslettersSort', newslettersSort)
            } else {
                store.dispatch('updateNewslettersSort', ENUM.NEWSLETTERS.SORT.NOT_SET)
            }
        },
        
        updateShowScanMailboxesEnding: (store, value) => {
            store.commit('SHOW_SCAN_MAILBOXES_ENDING', value)
        },

        updateActualPartner: (store, actualPartner) => {
            store.commit('ACTUAL_PARTNER', actualPartner)
        },

        updateNewslettersSearchingMode: (store, mode) => {
            store.commit('NEWSLETTERS_SEARCHING_MODE', mode)
        },
        updateSearchValue: (store, value) => {
            store.commit('UPDATE_SEARCH_VALUE', value)
        },

        updateNewslettersPage(store, newPage) {
            store.commit('UPDATE_NEWSLETTERS_PAGE', newPage)
        },

        updateCardDraging(store, bool) {
            store.commit('UPDATE_CARD_DRAGING', bool)
        },

        updateCardDragDirection(store, direction) {
            store.commit('UPDATE_CARD_DRAG_DIRECTION', direction)
        },

        updateEmailToDeleteRedirect(store, emailToDeleteRedirect = '') {
            Storage.setItem('emailToDeleteRedirect', emailToDeleteRedirect)
            store.commit('EMAIL_TO_DELETE_REDIRECT', emailToDeleteRedirect)
        }

    },
    strict: true
})
